import { motion } from 'framer-motion';
import { ShieldCheck, BadgeCheck, HandHeart } from 'lucide-react';

const PILLARS = [
  {
    icon: ShieldCheck,
    title: 'Confidence',
    desc: 'Clear communication, every step of the way.',
  },
  {
    icon: BadgeCheck,
    title: 'Professionalism',
    desc: 'Trained experts and disciplined execution.',
  },
  {
    icon: HandHeart,
    title: 'Care',
    desc: 'Genuine warmth for every family we visit.',
  },
];

/**
 * BrandPromise — compact signature band featuring the Brand Promise trio
 * (Confidence · Professionalism · Care). Exact copy from the BookMyJab
 * Brand Identity deck, Slide 7. Non-CTA, informational strip.
 */
export default function BrandPromise() {
  return (
    <section
      id="brand-promise"
      data-testid="brand-promise-section"
      className="bg-white border-y border-[#673c96]/10"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-8 md:mb-10"
        >
          <span
            className="text-[11px] font-semibold uppercase tracking-[0.22em] text-[#f37721]"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            Our Brand Promise
          </span>
          <h2
            className="mt-3 text-2xl sm:text-3xl font-bold text-[#311b52]"
            style={{ fontFamily: 'Poppins, sans-serif' }}
          >
            Every experience delivered with absolute certainty,
            <br className="hidden sm:block" /> flawless professionalism, and profound care.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
          {PILLARS.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              data-testid={`brand-pillar-${p.title.toLowerCase()}`}
              className="rounded-2xl border border-[#673c96]/10 bg-[#fbf8f2] px-5 py-5 flex items-start gap-4"
            >
              <div className="w-10 h-10 shrink-0 rounded-xl bg-[#311b52]/8 flex items-center justify-center">
                <p.icon className="w-5 h-5 text-[#311b52]" />
              </div>
              <div>
                <div
                  className="text-sm font-bold text-[#311b52]"
                  style={{ fontFamily: 'Poppins, sans-serif' }}
                >
                  {p.title}
                </div>
                <div
                  className="mt-1 text-[13px] text-[#3e195e]/80 leading-relaxed"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  {p.desc}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
